import type { FaireCategoryEntity } from "../../entity_types/category";

export const cat_women_screen_printed: FaireCategoryEntity = {
  token: "cat_women-screen-printed",
  type: "category",
  name: "Screen printed t-shirts",
  level: 3,
  parentToken: "cat_apparel-women",
  href: "/category/women/screen-printed-tshirts",
  meta: {
    source: "mock" as const,
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "data-model-migration",
  },
};
